import {useEffect, useState} from "react";
import {IPeriod} from "../../utils/interfaces/IPeriod";
import InvoiceRow from "./InvoiceRow";
import {IInvoice} from "../../utils/interfaces/IInvoice";
import {motion} from "framer-motion";


interface InvoicesListProps {
    obj: IPeriod,
}

function InvoicesList({obj: initialObj}: InvoicesListProps) {
    const [obj, setObj] = useState<IPeriod>(initialObj)

    const mapped_objs = obj?.invoices.map((obj: IInvoice, index) => (
        <motion.div
            key={obj.restaurateur.name}
            initial={{x: '150%'}}
            animate={{x: '0%'}}
            transition={{duration: 0.2, delay: index * 0.03}}
            className='mb-5'
        >
            <InvoiceRow obj={obj}/>
        </motion.div>

    ));

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            {mapped_objs}
        </>
    )
}

export default InvoicesList;